import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { KernelProvider } from "@/kernel/KernelContext";
import { ThemeProvider } from "@/theme/ThemeContext";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import { ToastProvider } from "@/components/Toast";
import App from "./App";
import "@/styles/fonts.css";
import "@/styles/global.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <ConfirmProvider>
          <ToastProvider>
            <AuthProvider>
              <KernelProvider>
                <App />
              </KernelProvider>
            </AuthProvider>
          </ToastProvider>
        </ConfirmProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
